import { type LinkProps, useHref, useLinkClickHandler } from 'react-router';

import { TextButtonLink, type TextButtonLinkProps } from '@creditornot/cb-button';

type Props = LinkProps &
  TextButtonLinkProps & {
    ref?: React.Ref<HTMLAnchorElement>;
  };

// https://reactrouter.com/en/main/upgrading/v5#remove-link-component-prop
const TextButtonLinkRRD: React.FunctionComponent<Props> = function TextButtonLinkRRDForwarded({
  onClick,
  replace = false,
  state,
  target,
  to,
  ref,
  ...rest
}) {
  const href = useHref(to);
  const handleClick = useLinkClickHandler(to, {
    replace,
    state,
    target,
  });

  return (
    <TextButtonLink
      {...rest}
      href={href}
      onClick={event => {
        onClick?.(event);
        if (!event.defaultPrevented) {
          handleClick(event);
        }
      }}
      ref={ref}
      target={target}
    />
  );
};

export default TextButtonLinkRRD;
